/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { baseComponentManager } from '../../registry/Components';
import {
  ComponentManagerFn,
  PropertyDefinitions,
} from '../../registry/Component.type';
import { ItemType } from '../../registry/ComponentRegistry';
import { defaultValue, DragSource } from './DragSource';
import { CommonProps } from '../../layout/Sidebar/panels/PropertiesView/CommonProperties';

export const DragSourceProps: PropertyDefinitions<
  Omit<DragSource, keyof CommonProps>
> = {
  type: {
    label: 'Type',
    type: 'string',
    helpText:
      'You can specify a type value for this drag source. Only the Drop Targets with the same type will react to this item.',
    required: true,
  },
  canDragCondition: {
    label: 'Can Drag Condition',
    type: 'expressionOnly',
    returnType: () => 'boolean',
  },
  canDrag: {
    label: 'canDrag Function',
    type: 'controllerFunction',
    category: 'Controllers',
  },
  beginDrag: {
    label: 'beginDrag Function',
    type: 'controllerFunction',
    category: 'Controllers',
  },
};

const DragSourceManager: ComponentManagerFn<'DragSource'> = (
  platform: Platform,
) => {
  return {
    ...baseComponentManager<'DragSource'>(platform, 'DragSource'),
    type: 'DragSource',
    name: 'Drag Source',
    isChildAllowed: (page, item, childType) =>
      (['RowPanel', 'Card'] as ItemType[]).includes(childType),
    defaultValue,
    props: DragSourceProps,
    // getDisplayText: (item) => item.props.icon?.iconName ?? 'Choose icon!',
    category: 'Containers',
    icon: { iconName: 'hand-rock' },
    description:
      "Drag Source component used to bind it in a drag wrapper. This will allow it's content to be dragged across the browser.",
  };
};

export default DragSourceManager;
